import { render, staticRenderFns } from "./TagModal.vue?vue&type=template&id=200b1a38&scoped=true"
import script from "./TagModal.vue?vue&type=script&lang=js"
export * from "./TagModal.vue?vue&type=script&lang=js"
import style0 from "./TagModal.vue?vue&type=style&index=0&id=200b1a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b1a38",
  null
  
)

export default component.exports